export default __webpack_public_path__ + "static/diamond-3-2c54de268cc6d5bcd363ce1ccc00ff15.png";